import { Grid } from '@material-ui/core'
import Card from 'src/components/sharedComponents/Card/Card'
import CardBody from 'src/components/sharedComponents/Card/CardBody'
import CardHeader from 'src/components/sharedComponents/Card/CardHeader'
import { useStyles } from '../styles'
import TableSegmentsMarketShare from '../../Tables/TableSegmentsMarketShare'

const TotalStreetByTerritoryCard = props => {
  const { totalSreetZone = [], selectedDate } = props
  const classes = useStyles()

  return (
    <Card>
      <CardHeader>
        <div className={classes.center}>
          <div>
            <h3>Total Street por zonas</h3>
          </div>
          {`  `}
        </div>
      </CardHeader>
      <CardBody>
        <Grid container spacing={3}>
          <Grid item xs={12} sm={12} lg={12}>
            <TableSegmentsMarketShare
              array={totalSreetZone}
              selectedDate={selectedDate}
              enableDate
              param="EMPRESA"
              order="TERRITORIO"
            />
          </Grid>
        </Grid>
      </CardBody>
    </Card>
  )
}

export default TotalStreetByTerritoryCard
